import { render, staticRenderFns } from "./ChoicesListTemplate.vue?vue&type=template&id=eb50646a&scoped=true"
import script from "./ChoicesListTemplate.vue?vue&type=script&lang=js"
export * from "./ChoicesListTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChoicesListTemplate.vue?vue&type=style&index=0&id=eb50646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb50646a",
  null
  
)

export default component.exports